import useAxios from 'hooks/useAxios';

export async function deleteBanner(id) {
  const api = useAxios();

  try {
    const res = await api.delete(`/banners/${id}`);
    return res;
  } catch (err) {
    return err;
  }
}


